<template>
  <b-modal
    id="edit-modal"
    ref="editModalRef"
    size="lg"
    title="Editar endereço"
    @ok="handleOk"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <div style="display: flex; gap: 2rem; width: 100%;">
        <b-form-group
          style="width: 100%;"
          label="Endereço"
          label-for="address-input"
          invalid-feedback="Endereço é obrigatório"
        >
          <b-form-input
            id="address-input"
            v-model="installationAddressForm.address"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="Bairro"
          style="width: 100%;"
          label-for="district-input"
          invalid-feedback="Bairro é obrigatório"
        >
          <b-form-input
            id="district-input"
            v-model="installationAddressForm.district"
            required
          ></b-form-input>
        </b-form-group>
      </div>
      <div style="display: flex; gap: 2rem; width: 100%;">
        <b-form-group
          label="Cidade"
          style="width: 100%;"
          label-for="city-input"
          invalid-feedback="Cidade é obrigatório"
        >
          <b-form-input
            id="city-input"
            v-model="installationAddressForm.city"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="Estado"
          style="width: 100%;"
          label-for="state-input"
          invalid-feedback="Estado é obrigatório"
        >
          <b-form-input
            id="state-input"
            v-model="installationAddressForm.state"
            required
          ></b-form-input>
        </b-form-group>
      </div>
      <div style="display: flex; gap: 2rem; width: 100%;">
        <b-form-group
          label="Número"
          style="width: 100%;"
          label-for="number-input"
          invalid-feedback="Número é obrigatório"
        >
          <b-form-input
            id="number-input"
            v-model="installationAddressForm.number"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="CEP"
          style="width: 100%;"
          label-for="zipCode-input"
          invalid-feedback="CEP é obrigatório"
        >
          <b-form-input
            id="zipCode-input"
            v-model="installationAddressForm.zipCode"
            required
          ></b-form-input>
        </b-form-group>
      </div>
    </form>
  </b-modal>
</template>

<script>
/// <reference path="../../common/types/index.js" />
import { Api } from '../../../vue/api';
const API = new Api();

export default {
  name: 'EditInstallationModal',
  data() {
    return {
      /**
       * @type {InstallationAddressForm}
       */
      installationAddressForm: {
        id: '',
        city: '',
        state: '',
        address: '',
        district: '',
        number: '',
        zipCode: '',
      },
    };
  },
  methods: {
    async handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      await this.handleSubmit();
    },
    openModal(installation) {
      this.installationAddressForm = installation;
      this.$refs.editModalRef.show();
    },
    async handleSubmit() {
      for (const field of Object.values(this.installationAddressForm)) {
        if (!field) {
          this.$bvToast.toast('Preencha todos os campos!', {
            title: `Erro`,
            variant: 'error',
            solid: true,
          });
          return;
        }
      }
      try {
        await API.post('/execute', {
          path: `/installation/edit`,
          method: 'post',
          data: this.installationAddressForm,
        });
        this.$emit('getAll');
      } catch (error) {
        this.$bvToast.toast(error.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
      } finally {
        this.$refs.editModalRef.hide('edit-modal');
      }
    },
  },
};
</script>
